import styled from 'styled-components'

import { mq, sizes } from '../../../theme'

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.colors.snow};
  padding: 3rem 1rem 1.5rem;
  gap: 3rem;
  @media ${mq(sizes.tablet)} {
    padding: 3rem 2rem;
  }
`
export const Title = styled.div`
  ${({ theme }) => theme.textStyles.titleH3};
  color: ${({ theme }) => theme.colors.arapawa};
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.titleH2};
  }
  @media print {
    ${({ theme }) => theme.textStyles.titleH5};
  }
`

export const Ingredients = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media print {
    gap: 0.5rem;
  }
`

export const Step = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gainsboro};
  &:last-of-type {
    border-bottom: none;
  }
`
